import type { FlatBoard } from './useReview'

/**
 * The public link uses only `gameId-ply`, for example
 * `c78848a9895d939f-23`. The axis prefix and the database-version prefix stay
 * internal. Full ids remain accepted for backwards compatibility.
 */
export function findBoardIndexById(boards: FlatBoard[], requestedId: string): number {
  const exact = boards.findIndex(
    ({ board }) => board.id === requestedId || board.id.endsWith(`:${requestedId}`),
  )
  if (exact >= 0) return exact

  const matches = boards.flatMap(({ board }, index) =>
    `${board.gameId}-${board.ply}` === requestedId ? [index] : [],
  )
  return matches.length === 1 ? matches[0]! : -1
}
